import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMotherC.module.scss";

function PageMotherC() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p15", "png", s.content);
  const notice = getImgSet("notice__p15", "png");
  const pointer = getImgSet("pointer__mother", "png", s.pointer);

  const back = getImgSet("back__p22", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/mother/d" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>{content}</div>
      <div className={s.aside_right}>
        <Link to="/mother/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageMotherC);
